import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Work',
    href: '#our-work'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-184">
        {/* Logo */}
        <a href="#" className="text-2xl font-heading font-bold text-navy tracking-tight" data-id="element-185">
          3techno <span className="text-teal" data-id="element-186">Digital</span>
        </a>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-187">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-teal transition-colors" data-id="element-188">
              {link.name}
            </a>)}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:block" data-id="element-189">
          <a href="https://calendly.com/fahad-3techno/strategy-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white bg-navy rounded-lg hover:bg-navy-light transition-colors shadow-sm" data-id="element-190">
            Get a Free Store Audit
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-gray-600 hover:text-navy focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-191">
          {isMobileMenuOpen ? <XIcon size={24} data-id="element-192" /> : <MenuIcon size={24} data-id="element-193" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-194">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-195">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-196">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-gray-800 hover:text-teal transition-colors py-2" data-id="element-197">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/fahad-3techno/strategy-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 mt-4 text-base font-medium text-white bg-navy rounded-lg hover:bg-navy-light transition-colors shadow-sm w-full" data-id="element-198">
                Get a Free Store Audit
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}